var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "sidenav"
  }, _vm._l((_vm.sections), function(section, index) {
    return _c('div', {
      key: section.title,
      staticClass: "sidenav-item"
    }, [_c('a', {
      attrs: {
        "href": '#' + section.title
      }
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), (index < (_vm.sections.length - 1)) ? _c('div', {
      staticClass: "dot"
    }) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.token) ? _c('router-link', {
    staticClass: "edit-button",
    attrs: {
      "to": "/edit-gallery"
    }
  }, [_vm._v("Edit Gallery")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Pieces by Marcia Halperin")]), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, _vm._l((_vm.sections), function(section, sectionIndex) {
    return _c('div', {
      key: section.title,
      staticClass: "section"
    }, [_c('h3', {
      staticClass: "section-title",
      attrs: {
        "id": section.title
      }
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('div', {
      staticClass: "piece-list"
    }, _vm._l((section.pieces), function(piece, pieceIndex) {
      return _c('piece', {
        key: piece.url,
        attrs: {
          "piece": piece,
          "img-prefix": _vm.imgPrefix
        },
        nativeOn: {
          "click": function($event) {
            _vm.selectPiece(sectionIndex, pieceIndex)
          }
        }
      })
    }))])
  }))], 1), _vm._v(" "), (_vm.selected) ? _c('modal', {
    attrs: {
      "urlPrefix": _vm.imgPrefix,
      "piece": _vm.sections[_vm.selected.section].pieces[_vm.selected.piece]
    },
    on: {
      "close": function($event) {
        _vm.selected = null
      },
      "moveLeft": function($event) {
        _vm.onMoveLeft()
      },
      "moveRight": function($event) {
        _vm.onMoveRight()
      }
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce4d200","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = x2uO
// module chunks = 1